import { Simplicity } from './Simplicity';

export default Simplicity;
